document.addEventListener('DOMContentLoaded', (event) => {
	// Search Toggle
	document.querySelector('.search-toggle').addEventListener('click', (event) => {
		document.body.classList.toggle('search-open');
	});

	// Menu Toggle
	document.querySelector('.burger-toggle').addEventListener('click', (event) => {
		document.body.classList.toggle('menu-open');
	});

	// dropdown toggle
	document.querySelector('.menu-item-has-children > a, .menu-item-has-children > span').addEventListener('click', (event) => {
		event.preventDefault();

		if (this) {
			const item = this.parentElement;

			item.classList.toggle('open');
		}
	});

	SwipersInit();

	function filterSelects() {
		const selects = document.querySelectorAll('.posts-filter__selects select');
		const hiddenInputs = document.querySelectorAll('.posts-filter__selects-hidden');

		function filterChange(event) {
			let query = [];

			hiddenInputs.forEach((input) => {
				if (input.name === 'postview' && input.value === 'all') {
					query.push(`post_type[]=post&post_type[]=media_centre_post`);
				}
				query.push(`${input.name}=${input.value}`);
			});

			selects.forEach((select) => {
				if (select.value === 'none') {
					query.push(`${select.dataset.select}=`);
					if (select.id === 'date-select') {
						const datevalue = select.value.split('-');
						query.push(`year=`);
						query.push(`monthnum=`);
					}
				} else {
					query.push(`${select.dataset.select}=${select.value}`);
					if (select.id === 'date-select') {
						const datevalue = select.value.split('-');
						query.push(`year=${datevalue[0]}`);
						query.push(`monthnum=${datevalue[1]}`);
					}
				}
			});

			window.location.href = `?${query.join('&')}`;
		}

		selects.forEach((select) => select.addEventListener('change', filterChange));
	}
	filterSelects();

	function nicerFileInput() {
		const input = document.querySelector('.job-form-file input[type=file');

		if (!input) return;

		input.addEventListener('change', () => (input.style.display = 'block'));
	}
	nicerFileInput();

	function addClassToTable() {
		const tables = document.querySelectorAll('.tablepress');

		tables.forEach((table) => {
			table.classList.add('table', 'table-hover');
		});
	}

	addClassToTable();

	function projectMapInit() {
		const map = document.getElementById('projects-map-section__map');
		const svgMap = document.getElementById('projects-map-section__svg-map');

		if (map) {
			const pins = document.querySelectorAll('.projects-map-section__pin');

			if (pins) {
				function projectsMap() {
					const mapWidth = map.offsetWidth, // in pixels
						mapHeight = map.offsetHeight, // in pixels
						mapLngLeft = -10.4198979, // in degrees. the longitude of the left side of the map (i.e. the longitude of whatever is depicted on the left-most part of the map image)
						mapLngRight = 1.766667, // in degrees. the longitude of the right side of the map
						mapLatBottom = 49.9596495;

					pins.forEach((pin) => {
						const lat = Number(pin.dataset.lat);
						const lng = Number(pin.dataset.lng);

						const coods = convertGeoToPixel(lat, lng, mapWidth, mapHeight, mapLngLeft, mapLngRight, mapLatBottom);

						// pin.style.transform = `translate(${coods.x}px, ${coods.y}px)`;
						pin.style.left = `${coods.x}px`;
						pin.style.top = `${coods.y}px`;

						new bootstrap.Tooltip(pin);
					});
				}

				projectsMap();

				window.addEventListener('resize', () => {
					projectsMap();
				});
			}

			function initZoom() {
				const outer = document.querySelector('.projects-map-section__zoom-wrapper');
				const inner = document.querySelector('.projects-map-section__full-width');

				if (!outer || !inner) {
					return false;
				}

				var wzoom = WZoom.create(inner, {
					type: 'html',
					width: outer.offsetWidth,
					height: outer.offsetHeight,
					minScale: 1,
					maxScale: 6,
					speed: 5,
					zoomOnClick: false,
					dragScrollableOptions: {
						onGrab: function () {
							outer.style.cursor = 'grabbing';
						},
						onDrop: function () {
							outer.style.cursor = 'grab';
						},
					},
					rescale: function () {
						outer.style.setProperty('--pin-scale', 1 / wzoom.content.currentScale);
					},
				});

				window.addEventListener('resize', function () {
					wzoom.prepare();
				});

				document.querySelector('[data-zoom-up]').addEventListener('click', function () {
					wzoom.zoomUp();
				});

				document.querySelector('[data-zoom-down]').addEventListener('click', function () {
					wzoom.zoomDown();
				});
			}

			if (map.complete) {
				initZoom();
			} else {
				map.onload = initZoom;
			}
		}

		if (svgMap) {
			// enable tooltips in map svg
			svgMap.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((item) => {
				new bootstrap.Tooltip(item, {
					popperConfig: () => {
						return {
							placement: 'top',
							container: svgMap,
						};
					},
				});
			});
		}

		function convertGeoToPixel(
			latitude,
			longitude,
			mapWidth, // in pixels
			mapHeight, // in pixels
			mapLngLeft, // in degrees. the longitude of the left side of the map (i.e. the longitude of whatever is depicted on the left-most part of the map image)
			mapLngRight, // in degrees. the longitude of the right side of the map
			mapLatBottom
		) {
			// in degrees.  the latitude of the bottom of the map
			const mapLatBottomRad = (mapLatBottom * Math.PI) / 180;
			const latitudeRad = (latitude * Math.PI) / 180;
			const mapLngDelta = mapLngRight - mapLngLeft;

			const worldMapWidth = ((mapWidth / mapLngDelta) * 360) / (2 * Math.PI);
			const mapOffsetY = (worldMapWidth / 2) * Math.log((1 + Math.sin(mapLatBottomRad)) / (1 - Math.sin(mapLatBottomRad)));

			const x = (longitude - mapLngLeft) * (mapWidth / mapLngDelta);
			const y = mapHeight - ((worldMapWidth / 2) * Math.log((1 + Math.sin(latitudeRad)) / (1 - Math.sin(latitudeRad))) - mapOffsetY);

			return { x, y }; // the pixel x,y value of this point on the map image
		}
	}

	projectMapInit();

	window.filterButtons = function(container) {
		container = container || document;

		const selects = container.querySelectorAll('.select-styled');
		const hiddenInputs = container.querySelectorAll('.posts-filter__selects-hidden');

		container.addEventListener('click', (event) => {
			if(!event.target.closest('.select-styled')) {
				closeSelects();
			}
		});

		function filterChange(select, event) {
			event.preventDefault();

			let query = [];

			const name = event.target.dataset.name;
			const value = event.target.dataset.value;

			const submit_on_change = (select.dataset.noSubmit === undefined);

			const hidden = select.querySelector(`.posts-filter__selects-hidden[name=${name}`);
			hidden.value = value;

			hidden.dispatchEvent(new Event('input', {
				bubbles: true
			}));

			select.classList.toggle('open');

			const btn = select.querySelector(`.select-styled__label`);

			if (value) {
				if (name === 'daterange') {
					const date = new Date(value);
					const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

					btn.textContent = months[date.getMonth()] + ' ' + date.getFullYear();
					const hiddenMonth = select.querySelector(`.posts-filter__selects-hidden[name=monthnum]`);
					const hiddenYear = select.querySelector(`.posts-filter__selects-hidden[name=year]`);

					hiddenMonth.value = date.getMonth() + 1;
					hiddenYear.value = date.getFullYear();
				} else {
					btn.textContent = value.replace(/-/g, ' ');
				}
			} else {
				btn.textContent = btn.dataset.label;
				if (name === 'daterange') {
					const hiddenMonth = select.querySelector(`.posts-filter__selects-hidden[name=monthnum]`);
					const hiddenYear = select.querySelector(`.posts-filter__selects-hidden[name=year]`);

					hiddenMonth.value = '';
					hiddenYear.value = '';
				}
			}

			hiddenInputs.forEach((input) => {
				if (input.name === 'postview' && input.value === 'all') {
					query.push(`post_type[]=post&post_type[]=media_centre_post`);
				}
				query.push(`${input.name}=${input.value}`);
			});

			if (submit_on_change) {
				window.location.href = `?${query.join('&')}`;
			}
		}

		function openSelect(select) {
			const is_open = select.classList.contains('open');

			closeSelects();

			if(!is_open) {
				select.classList.toggle('open');
			}
		}

		function closeSelects() {
			selects.forEach((select) => {
				select.classList.remove('open');
			});
		}

		selects.forEach((select) => {
			select.addEventListener('click', (event) => {
				const element = event.target;

				if(element.classList.contains('select-styled__label')) {
					openSelect(select)
				}
				else if(element.tagName === 'A') {
					filterChange(select, event);
				}
			});
		});
	}
	filterButtons();

	window.initResources = function() {
		const ajax_pagination = document.querySelector('#resources-ajax-pagination');
		const ajax_filters = document.querySelector('#resources-ajax-filters');
		const ajax_container = document.querySelector('#resources-ajax');
		let first_load = true;

		const filters = {
			page: 1
		};

		if(!ajax_container || !ajax_pagination) {
			return false;
		}

		getResources();
		initPagination();
		initFilters();

		function updateFilters(data) {
			Object.keys(data).forEach(filterName => {
				const filterValues = data[filterName];
				const element = ajax_filters.querySelector(`.select-styled[data-name=${filterName}] .select-styled__dropdown-inner`);
				const html = [];

				if (element) {
					Object.values(filterValues).forEach(item => {
						html.push(`<a href="?${filterName}=${item.slug}" data-name="${filterName}" data-value="${item.slug}">${item.name}</a>`)
					});

					element.innerHTML = html.join('');
				}
			});
		}

		function getResources() {
			// prevent getting the same page again
			if(filters.page == ajax_pagination.dataset.page) {
				return false;
			}

			ajax_container.classList.add('loading');

			jQuery.ajax({
				url: projectMapAJAX.ajaxurl,
				type: 'post',
				data: {
					action: 'kwb_ajax_resources',
					nonce: projectMapAJAX.nonce,
					post_id: ajax_container.dataset.projectId,
					filters: filters,
					get_filters: first_load,
				},
				success: function (response) {
					response = JSON.parse(response);

					if (typeof response.filters === 'object') {
						updateFilters(response.filters);
					}

					ajax_container.innerHTML = response.html;

					ajax_container.classList.remove('loading');

					filters.page = response.pagination.page || 1;
					filters.pageCount = response.pagination.page_count || 1;

					updatePagination();

					first_load = false;
				},
			});
		}

		function initFilters() {
			if(!ajax_filters) {
				return false;
			}

			const inputs = ajax_filters.querySelectorAll('.js-filter-input');

			inputs.forEach((input) => {
				input.addEventListener('input', (e) => {
					filters[e.target.name] = e.target.value;

					getResources();
				});
			});
		}

		function initPagination() {
			const resourcesPageControlBtn = ajax_pagination.querySelectorAll('.js-resources-page-control');

			if (resourcesPageControlBtn.length > 0) {
				resourcesPageControlBtn.forEach((btn) => {
					btn.addEventListener('click', (e) => {
						e.preventDefault();

						const btn = e.target;
						const next = btn.classList.contains('next');
						let newPage = next ? filters.page + 1 : filters.page - 1;

						if (newPage < 1) {
							newPage = 1;
						} else if (newPage > filters.pageCount) {
							newPage = filters.pageCount;
						}

						filters.page = newPage;

						getResources();
					});
				});
			}
		}

		function updatePagination() {
			const paginationBtnPrev = ajax_pagination.querySelector('.js-resources-page-control.prev');
			const paginationBtnNext = ajax_pagination.querySelector('.js-resources-page-control.next');

			const currentPageElement = ajax_pagination.querySelector('.js-resources-page-current');
			const pageCountElement = ajax_pagination.querySelector('.js-resources-page-count');

			paginationBtnPrev.classList.toggle('d-none', filters.page <= 1);
			paginationBtnNext.classList.toggle('d-none', filters.page >= filters.pageCount);

			currentPageElement.innerHTML = filters.page;
			pageCountElement.innerHTML = filters.pageCount;
		}
	}
	initResources();

	function initLightbox() {
		jQuery().fancybox({
			selector : '[data-fancybox="gallery"]',
			buttons: [
				"close"
			],
			arrows: false,
		});
	}
	initLightbox();

	// prevent iframes stealing scroll event
	let iframes;
	let iframesLocked = null;

	window.addEventListener('scroll', iframeScroll, true);

	function iframeScroll(e) {
		if (!iframesLocked) {
			iframes = document.querySelectorAll('iframe');

			iframeLock('none');
		}

		clearTimeout(iframesLocked);

		iframesLocked = setTimeout(function () {
			iframesLocked = null;

			iframeLock('auto');
		}, 100);
	}

	function iframeLock(value) {
		for (let i = 0; i < iframes.length; i++) {
			iframes[i].style.pointerEvents = value;
		}
	}
});
